<script>
  import { fade } from 'svelte/transition';
  import { tweened } from 'svelte/motion';
  import { groups } from './helper.js';
  export let initialized = false;

  export let type = 'bands';

  export let scale;
  export let index;

  export let specData = {};
  // export let key;
  export let data = [];
  // export let domain = [0, 0];
  export let width = 200;
  export let height = 100;

  function getClass(d, index, type) {
    let c = '';

    if (type == 'spectrum') {
      if (index == 0) {
        if ('fed' in d && !('nonFed' in d)) {
          c += 'fed ';
        } else if ('fed' in d && 'nonFed' in d) {
          c += 'shared ';
        } else if (!('fed' in d) && 'nonFed' in d) {
          c += 'nonfed ';
        }
      } else {
        c += d.key + ' ';
      }
      return c;
    }

    c += d.key + ' ';
    return c;
  }

  function getBlockClass(key) {
    if (key == 'MOBILE') {
      return 'mobile';
    } else if (key == 'BROADCASTING') {
      return 'broadcast';
    }
    return 'other';
  }
</script>

<style type="text/scss">svg {
  height: 100%;
  width: 100%; }

rect.init {
  transition: y 2000ms linear, opacity 1000ms linear, height 2000ms linear; }

.inactive {
  opacity: 0;
  transition: opacity 1000ms 1000ms; }
</style>

<svg class="index-{index}" viewBox="0 0 {width} {height}" {width} {height}>

  {#if type == 'bands'}
    {#each data as d (d.key)}
      <rect
        class="spectrum-range b-{getClass(d, index, type)}
        {d.state}
        {initialized ? 'init' : ''}"
        y={scale(d.end)}
        x={2}
        width={width - 4}
        height={scale(d.start) - scale(d.end) > 2 ? scale(d.start) - scale(d.end) : 2} />
    {/each}
  {:else}
    {#each specData.control as d}
      <rect
        date-range={d.range}
        class="spectrum-range b-{d.control}
        {initialized ? 'init' : ''}"
        y={scale(d.end)}
        width={width - 2}
        x={2}
        height={scale(d.start) - scale(d.end) > 2 ? scale(d.start) - scale(d.end) : 2} />
    {/each}

    {#each specData.groups as group, i}
      <g class="g-{group.class} {index >= 1 ? 'g-active' : 'g-inactive'}">
        {#each group.blocks as d (d.key)}
          <rect
            class="b-{group.class} b-base {initialized ? 'init' : ''}"
            x={i * (width / specData.groups.length)}
            y={scale(d.end)}
            rx={2}
            width={width / specData.groups.length - 2}
            height={scale(d.start) - scale(d.end) > 2 ? scale(d.start) - scale(d.end) : 2} />
        {/each}
        <!-- 
      <text x={i * (width / specData.groups.length)} y="10" class="b-label">
        {group.label}
      </text> -->
      </g>
    {/each}

    <g class="g-auction {index >= 3 ? 'g-active' : 'g-inactive'}">
      {#each specData.auction as d (d.key)}
        <rect
          class="spectrum-range b-auction b-{getClass(d, index, type)}
          {d.state}
          {initialized ? 'init' : ''}"
          y={scale(d.end)}
          x={2}
          width={width - 4}
          height={scale(d.start) - scale(d.end)} />
      {/each}
    </g>
  {/if}

</svg>

{#if type == 'spectrum' && index == 1}
  {#each specData.groups as group, i}
    <div
      class="spec-label"
      style="left: {(i + 1) * (width / specData.groups.length)}px; width: {height}px;
      line-height:{width / specData.groups.length}px;">
      {group.name}
    </div>
  {/each}
{/if}
